import { createSelector } from 'redux-starter-kit';

export default {
  tables: createSelector(['reports.tables']),
  htmls: createSelector(['reports.htmls']),
};
